import { ADDRESS_REQUIREMENTS_BY_COUNTRY, PROVINCES_BY_COUNTRY, SUPPORTED_COUNTRIES, } from '../types/address';
export * from './addressHelpers/deprecated';
export const getCountriesForRegion = (region) => {
    return SUPPORTED_COUNTRIES.filter((country) => country.region === region);
};
export const getProvincesForCountry = (country) => {
    return PROVINCES_BY_COUNTRY[country] ?? [];
};
export const getAddressRequirementsForCountry = (country) => {
    return ADDRESS_REQUIREMENTS_BY_COUNTRY[country] ?? [];
};
/**
 * Validates a single field of a user-entered address.
 * Use react-hook-form's register to do this validation instead if possible.
 * @param field Address field / requirements
 * @param input User inputted value
 * @returns If the field passed all validations or if not, what validation failed
 */
export const validateAddressInput = (field, input) => {
    if (!input) {
        return field.required
            ? { isValid: false, errorType: 'required' }
            : { isValid: true };
    }
    if (field.pattern && !field.pattern.exec(input)) {
        return { isValid: false, errorType: 'pattern' };
    }
    if (field.minLength && input.length < field.minLength) {
        return { isValid: false, errorType: 'minLength' };
    }
    if (field.maxLength && input.length > field.maxLength) {
        return { isValid: false, errorType: 'maxLength' };
    }
    return { isValid: true };
};
export const getAddressFieldValidationRequirements = (field) => {
    return {
        required: field.required,
        minLength: field.minLength,
        maxLength: field.maxLength,
        pattern: field.pattern,
    };
};
export const getAddressFieldErrorKey = (field, errorType) => {
    if (errorType === 'maxLength')
        return 'maxLengthError';
    return `validityError${field.example ? 'WithExample' : ''}`;
};
